import React from 'react'
import { Button, BodyText } from '@paypalcorp/pp-react'
import Proptypes from 'prop-types'
import { trackClick } from 'ppbl/utils/fpti-helper'
import { useApplicationContext } from 'ppbl/hooks'
import Logo from '../../Logo'
import { generateProps } from './__utils__'
import './index.css'

export const fptiClick = (e, text, page) => {
  const fptiData = {
    page,
    component: 'HeaderSection',
    link: `HeaderSection_${e.text ? e.text : text}_button`,
  }

  trackClick(fptiData)
}
export default function HeaderSection({ page }) {
  const { data } = useApplicationContext()
  const legalBusinessName = data?.applicationMetaData?.legalBusinessName
  const {
    logo,
    headerPrimaryLink,
    loginInfo,
    isPPBL,
    product = 'app',
  } = generateProps()
  const renderOnlyLogo =
    page === 'applicationPage' ||
    page === 'privacyPage' ||
    page === 'startPage' ||
    page === 'calculatorPage'

  const renderMainLogo = (logoImage) => {
    if (logoImage) {
      const {
        text = 'PayPal',
        href = '/merchant-lending/loanbuilder',
        imageUrl = logoImage.imageUrl,
      } = logoImage
      return (
        <Logo
          data-testid="header-main-logo"
          text={text}
          href={href}
          url={imageUrl}
          className={isPPBL ? 'ppbl-logo-rebrand' : 'loanbldr-logo-rebrand'}
          data-pa-click="Header-Logo-PayPal Logo"
          onClick={(e) => fptiClick(e, text, page)}
        />
      )
    }
    return null
  }

  return (
    // Add actual loan builder logo once CDN is updated.
    <>
      <div id="headerSection">
        <header
          className="common-header grid"
          data-building-block="organism"
          translate="no"
        >
          <div className="container">
            <div className="header-container">
              <div className="common-sub-header">
                <div
                  id="header_loanbldrLogo"
                  className={isPPBL ? 'ppbl-logo' : 'loanbldr-logo'}
                >
                  {renderMainLogo(logo)}
                </div>
                {renderOnlyLogo ? (
                  <></>
                ) : (
                  <div>
                    <a
                      id="header_resourceLink"
                      onClick={(e) =>
                        fptiClick(e, headerPrimaryLink.text, page)
                      }
                      className="header-primary-link"
                      href={headerPrimaryLink.url}
                    >
                      {headerPrimaryLink.text}
                    </a>
                  </div>
                )}
              </div>
              {renderOnlyLogo ? (
                <>
                  {product !== 'app' && legalBusinessName ? (
                    <BodyText className="header-business-name">
                      {legalBusinessName}
                    </BodyText>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <div className="common-sub-header">
                  <div className="header-login">{loginInfo.text}</div>
                  <div className="login-button">
                    <Button
                      id="header_loginButton"
                      onClick={(e) => fptiClick(e, loginInfo.button.text, page)}
                      as="a"
                      href={loginInfo.button.url}
                      role="button"
                    >
                      {loginInfo.button.text}
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </header>
      </div>
    </>
  )
}

HeaderSection.propTypes = {
  page: Proptypes.string,
}
